import { render, staticRenderFns } from "./product-data.component.vue?vue&type=template&id=82e9c348&scoped=true"
import script from "./product-data.component.vue?vue&type=script&lang=js"
export * from "./product-data.component.vue?vue&type=script&lang=js"
import style0 from "./product-data.component.vue?vue&type=style&index=0&id=82e9c348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e9c348",
  null
  
)

export default component.exports